import _defineProperty from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "step first"
};
var _hoisted_2 = {
  class: "step-box"
};
var _hoisted_3 = {
  class: "set-box group-box"
};
var _hoisted_4 = {
  class: "group-nav"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "item-text"
};
var _hoisted_7 = {
  key: 0,
  class: "item-tips"
};
var _hoisted_8 = {
  class: "group-info"
};
var _hoisted_9 = {
  class: "title"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "group-member"
};
var _hoisted_12 = {
  class: "step-btns"
};
var _hoisted_13 = {
  key: 1,
  class: "step second"
};
var _hoisted_14 = {
  class: "step-box"
};
var _hoisted_15 = {
  class: "set-box set-release"
};
var _hoisted_16 = {
  class: "set-item"
};
var _hoisted_17 = {
  class: "set-item"
};
var _hoisted_18 = {
  class: "select_time"
};
var _hoisted_19 = {
  class: "set-item"
};
var _hoisted_20 = {
  class: "set-item"
};
var _hoisted_21 = {
  key: 0,
  class: "set-item"
};
var _hoisted_22 = {
  class: "set-item"
};
var _hoisted_23 = {
  class: "step-btns"
};
import dayjs from 'dayjs';
import { MessagePlugin } from 'tdesign-vue-next';
import { onMounted, ref, reactive, computed, watch, toRaw } from 'vue';
import { getStore } from '@/util/store';
import { getPubGroupList, getGroupInformation, getExercisesPaperPub } from '@/api/index-bei';
import { debounce } from '@/util/index';
export default {
  __name: 'PublishStep',
  props: {
    publishVisible: {
      type: Boolean,
      default: false
    },
    paper: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var visible = ref(props.publishVisible);
    var close = function close() {
      console.log('关闭弹窗');
      emit('close');
    };
    var steps = [{
      title: '选择发布对象',
      value: 'first'
    }, {
      title: '发布设置',
      value: 'second'
    }];
    var currentStep = ref('first');
    var changeStep = function changeStep(step) {
      currentStep.value = step;
    };
    var typeObj = {
      student: '学生',
      'teacher-student': '学生和教师',
      teacher: '教师'
    };
    var options = ref([{
      value: 0,
      label: '教师批阅',
      disabled: false
    }, {
      value: 1,
      label: '学生批阅',
      disabled: true
    }, {
      value: 2,
      label: '学生互批',
      disabled: true
    }]);
    var optionTwice = ref([{
      value: 0,
      label: '学生完成作答',
      disabled: false
    }, {
      value: 1,
      label: '教师完成批阅',
      disabled: false
    }, {
      value: 2,
      label: '手动控制',
      disabled: false
    }]);
    // 推荐用时绑定值
    var recommendTime = ref([{
      label: '不限',
      value: '不限'
    }, {
      label: '10分钟',
      value: 600
    }, {
      label: '15分钟',
      value: 900
    }, {
      label: '20分钟',
      value: 1200
    }, {
      label: '30分钟',
      value: 1800
    }, {
      label: '45分钟',
      value: 2700
    }, {
      label: '60分钟',
      value: 3600
    }, {
      label: '90分钟',
      value: 5400
    }, {
      label: '120分钟',
      value: 7200
    }]);
    var activeIndex = ref(0);
    var isShowAsync = ref(false);
    var operateType = ref('release');
    var noticeText = ref('到了开始时间，学生才能看到习练；到了结束时间，学生不能进行作答，只能查看');
    var noticeText2 = ref('设置推荐用时后，学生作答时右上角会展示已进行的时间，到了时间后，学生也仍然可以继续作答');
    var noticeText3 = ref('选择学生完成作答，学生完成作答后就可以看到习题的答案；选择教师完成批阅，老师完成批阅后，学生才能看到习题的答案；选择手动控制，老师可以手动控制学生是否能够查看答案');
    var state = reactive({
      checkGroups: [],
      // 已选群组
      allGroupsDisabled: false,
      checkStudents: [],
      // 已选群组学生
      groupList: [],
      // 群组列表
      pubGroupList: [],
      // 已发布群组列表
      timePickerProps: {},
      // 时间禁用
      practiceDate: [],
      // 习练 ------- 起止时间
      practiceAnswerTime: 1,
      // 习练 ------- 答案公布时机
      practiceReadWay: 0,
      // 习练 ------- 批阅方式
      recommendTimeShow: '不限',
      //, 习练 ------- 推荐用时
      practiceAnswerShow: false,
      // 习练 ------- 答案是否可见
      practiceIsPubToGroup: false // 习练 ------- 是否同步到群组动态
    });
    var getGroupList = function getGroupList() {
      var _getStore;
      var userId = (_getStore = getStore({
        name: 'userInfo'
      })) === null || _getStore === void 0 ? void 0 : _getStore.id;
      getPubGroupList(userId, props.paper.resId).then(function (res) {
        if (res.data.code === 0) {
          state.groupList = _toConsumableArray(setSelectArr(res.data.data));
          getPubInfo();
        }
      });
    };
    var setSelectArr = function setSelectArr(list) {
      if (list.length) {
        list.forEach(function (item) {
          item.checked = false;
          var arr = [];
          for (var k in item.members) {
            if (item.members[k].length) {
              arr.push(_defineProperty(_defineProperty({}, k, item.members[k].map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  checked: false
                });
              })), "checked", false));
            }
          }
          item.members = arr.reverse(); // 翻转 学生放最前
        });
        return list;
      } else {
        return [];
      }
    };
    var checkedArr = function checkedArr(list) {
      var choosedArr1 = [];
      choosedArr1 = list.reduce(function (pre, cur) {
        if (cur !== null && cur !== void 0 && cur.students) {
          pre.push.apply(pre, _toConsumableArray(cur.students));
        } else {
          if (cur !== null && cur !== void 0 && cur.publishUsers) {
            pre.push.apply(pre, _toConsumableArray(cur.publishUsers));
          }
        }
        return pre;
      }, []);
      return choosedArr1.length;
    };
    watch(function () {
      return state.groupList;
    }, function (val) {
      var choosedArr = [];
      if (val[0]) {
        if (Object.keys(val[0]).length) {
          val.forEach(function (item) {
            item === null || item === void 0 || item.members.forEach(function (ite) {
              ite[Object.keys(ite)[0]].forEach(function (it) {
                if (it.checked) {
                  choosedArr.push(it);
                }
              });
            });
          });
          if (choosedArr.length > checkedArr(state.checkStudents)) {
            isShowAsync.value = true;
          } else {
            isShowAsync.value = false;
          }
        }
      }
    }, {
      deep: true,
      immediate: true
    });
    var allGroupsChecked = computed({
      get: function get() {
        return state.groupList.every(function (group) {
          return group.checked;
        });
      },
      set: function set(value) {
        state.allGroupsChecked = value;
        changeAllGroups();
      }
    });
    // 全选
    var changeAllGroups = function changeAllGroups() {
      state.groupList.forEach(function (group) {
        group.checked = state.allGroupsChecked;
        group.halfChecked = false;
        group.members.forEach(function (member) {
          member.checked = state.allGroupsChecked;
          member.halfChecked = false;
          member[Object.keys(member)[0]].forEach(function (memberDetail) {
            if (!memberDetail.disabled) {
              memberDetail.checked = state.allGroupsChecked;
            }
          });
        });
      });
    };
    var changeGroup = function changeGroup(item, index) {
      activeIndex.value = index;
      changeStu();
      changeType();
    };
    // 选择班级
    var changeClass = function changeClass(item, index) {
      // 当存在老师身份时 班级只存在半选和不选
      if (state.groupList[index].members.some(function (ite) {
        var _ite$teacher;
        return ite === null || ite === void 0 || (_ite$teacher = ite.teacher) === null || _ite$teacher === void 0 ? void 0 : _ite$teacher.length;
      })) {
        state.groupList[index].halfChecked = state.groupList[index].checked;
        state.groupList[index].members.forEach(function (ite) {
          if (Object.keys(ite)[0] === 'teacher') {
            ite.disabled = true;
            ite[Object.keys(ite)[0]].forEach(function (it) {
              it.disabled = true;
            });
          }
          // 如果成员全部勾选 则班级半选
          if (!ite.disabled) {
            ite[Object.keys(ite)[0]].forEach(function (it) {
              if (!it.disabled) {
                it.checked = state.groupList[index].halfChecked;
              }
            });
            // 如果成员有一个勾选 则班级半选 对应的成员类型半选
            if (ite[Object.keys(ite)[0]].some(function (it) {
              return it.checked;
            })) {
              // Object.keys(ite)[0] teacher  Object.keys(ite)[1] checked  Object.keys(ite)[2] disable  Object.keys(ite)[3] halfChecked
              state.groupList[index].halfChecked = true;
              ite[Object.keys(ite)[1]] = false;
              ite[Object.keys(ite)[3]] = true;
            }
            if (ite[Object.keys(ite)[0]].every(function (it) {
              return !it.checked && !it.disabled;
            })) {
              // 如果成员都没选 则班级不选 对应的成员类型不选
              state.groupList[index].halfChecked = false;
              ite[Object.keys(ite)[1]] = false;
              ite[Object.keys(ite)[3]] = false;
            }
            // 如果成员都选 则班级半选 对应的成员类型全选
            if (ite[Object.keys(ite)[0]].every(function (it) {
              return it.checked;
            })) {
              state.groupList[index].halfChecked = true;
              ite[Object.keys(ite)[3]] = false;
              ite[Object.keys(ite)[1]] = true;
            }
          }
        });
      } else {
        // 当不存在老师身份时
        state.groupList[index].members.forEach(function (ite) {
          ite.checked = state.groupList[index].checked;
          ite.halfChecked = false;
          ite[Object.keys(ite)[0]].forEach(function (it) {
            if (!it.disabled) {
              it.checked = state.groupList[index].checked;
            }
          });
          // // 如果成员全选 则班级勾选
          if (ite[Object.keys(ite)[0]].every(function (it) {
            return it.checked;
          })) {
            state.groupList[index].halfChecked = false;
            state.groupList[index].checked = true;
            ite[Object.keys(ite)[1]] = true;
          } else if (ite[Object.keys(ite)[0]].some(function (it) {
            return it.checked;
          })) {
            state.groupList[index].halfChecked = true;
            state.groupList[index].checked = false;
            ite[Object.keys(ite)[2]] = true;
          } else if (ite[Object.keys(ite)[0]].every(function (it) {
            return !it.checked;
          })) {
            state.groupList[index].halfChecked = false;
            state.groupList[index].checked = false;
            ite[Object.keys(ite)[2]] = false;
            ite[Object.keys(ite)[1]] = false;
          }
        });
      }
    };

    // 选择身份
    var changeType = function changeType(index) {
      if (!state.groupList.length) return;
      if (index || index === 0) {
        state.groupList[activeIndex.value].members[index][Object.keys(state.groupList[activeIndex.value].members[index])[0]].forEach(function (it) {
          if (!it.disabled) {
            var _state$groupList$acti;
            it.checked = (_state$groupList$acti = state.groupList[activeIndex.value].members[index]) === null || _state$groupList$acti === void 0 ? void 0 : _state$groupList$acti.checked;
          }
        });
        if (state.groupList[activeIndex.value].members[index][Object.keys(state.groupList[activeIndex.value].members[index])[0]].every(function (i) {
          return i.checked;
        })) {
          state.groupList[activeIndex.value].members[index].halfChecked = false;
          state.groupList[activeIndex.value].members[index].checked = true;
        } else if (state.groupList[activeIndex.value].members[index][Object.keys(state.groupList[activeIndex.value].members[index])[0]].some(function (i) {
          return i.checked;
        })) {
          state.groupList[activeIndex.value].members[index].halfChecked = true;
          state.groupList[activeIndex.value].members[index].checked = false;
        } else {
          state.groupList[activeIndex.value].members[index].halfChecked = false;
          state.groupList[activeIndex.value].members[index].checked = false;
        }
        if (state.groupList[activeIndex.value].members.every(function (i) {
          return i.checked;
        })) {
          state.groupList[activeIndex.value].halfChecked = false;
          state.groupList[activeIndex.value].checked = true;
        } else if (state.groupList[activeIndex.value].members.some(function (i) {
          return i.checked;
        })) {
          state.groupList[activeIndex.value].checked = false;
          state.groupList[activeIndex.value].halfChecked = true;
        } else {
          state.groupList[activeIndex.value].checked = false;
          state.groupList[activeIndex.value].halfChecked = false;
        }
        if (state.groupList[activeIndex.value].members.some(function (i) {
          return i.halfChecked;
        })) {
          state.groupList[activeIndex.value].checked = false;
          state.groupList[activeIndex.value].halfChecked = true;
        }
      }
    };

    // 选择学生
    var changeStu = function changeStu(index) {
      if (!state.groupList.length) return;
      if (index || index === 0) {
        if (state.groupList[activeIndex.value].members[index][Object.keys(state.groupList[activeIndex.value].members[index])[0]].every(function (i) {
          return i.checked;
        })) {
          state.groupList[activeIndex.value].members[index].checked = true;
        } else {
          state.groupList[activeIndex.value].members[index].checked = false;
        }
      }
      if (state.groupList[activeIndex.value].members.every(function (it) {
        return it.checked;
      })) {
        state.groupList[activeIndex.value].checked = true;
        state.groupList[activeIndex.value].halfChecked = false;
      } else if (state.groupList[activeIndex.value].members.some(function (it) {
        return it.checked;
      })) {
        state.groupList[activeIndex.value].checked = false;
        state.groupList[activeIndex.value].halfChecked = true;
      } else {
        state.groupList[activeIndex.value].checked = false;
        state.groupList[activeIndex.value].halfChecked = false;
      }
      state.groupList[activeIndex.value].members.forEach(function (it) {
        if (it[Object.keys(it)[0]].every(function (i) {
          return i.checked;
        })) {
          it.checked = true;
          it.halfChecked = false;
        } else if (it[Object.keys(it)[0]].some(function (i) {
          return i.checked;
        })) {
          it.halfChecked = true;
          state.groupList[activeIndex.value].checked = false;
          state.groupList[activeIndex.value].halfChecked = true;
        } else {
          it.halfChecked = false;
          it.checked = false;
        }
      });
    };

    // 日期面板选择
    var datePick = function datePick(val) {
      var now = +new Date();
      var time = +new Date(val);
      if (time > now) {
        state.timePickerProps = {};
      } else {
        state.timePickerProps = {
          disableTime: function disableTime() {
            var hours = new Array(24).fill(null).map(function (_, i) {
              return i;
            });
            var times = new Array(60).fill(null).map(function (_, i) {
              return i;
            });
            var nowH = Number(dayjs().format('H'));
            var nowM = Number(dayjs().format('m'));
            var nowS = Number(dayjs().format('s'));
            return {
              hour: hours.filter(function (e) {
                return e < nowH;
              }),
              minute: times.filter(function (e) {
                return e < nowM;
              }),
              second: times.filter(function (e) {
                return e < nowS;
              })
            };
          }
        };
      }
    };

    // 日期变化
    var dateChange = function dateChange(val) {
      var now = +new Date();
      val.forEach(function (d, i) {
        var time = +new Date(d);
        time < now && (state.practiceDate[i] = dayjs().format('YYYY-MM-DD HH:mm'));
      });
    };

    // 获取已发布信息
    var getPubInfo = function getPubInfo() {
      getGroupInformation(props.paper.id).then(function (res) {
        if (res.data.code === 0) {
          state.pubGroupList = res.data.data || [];
          state.checkGroups = (res.data.data || []).map(function (e) {
            return e.groupId;
          });
          res.data.data.filter(function (item) {
            if (item !== null && item !== void 0 && item.students) {
              return item === null || item === void 0 ? void 0 : item.students.length;
            } else if (item !== null && item !== void 0 && item.members) {
              return item === null || item === void 0 ? void 0 : item.members.length;
            } else {
              return item === null || item === void 0 ? void 0 : item.publishUsers.length;
            }
          }).forEach(function (ite) {
            state.checkStudents.push(ite);
          });
          if (operateType.value === 'release') {
            // 发布操作，需要禁用已发布
            state.groupList.forEach(function (e) {
              state.checkStudents.forEach(function (i) {
                if (i.groupId === e.groupId) {
                  e === null || e === void 0 || e.members.forEach(function (item) {
                    item[Object.keys(item)[0]].forEach(function (ite) {
                      ite.disabled = e.operateType === 1;
                      if (i !== null && i !== void 0 && i.students) {
                        ite.disabled = e.operateType === 0 && i.students.some(function (i) {
                          return i.studentId === ite.userId;
                        });
                        ite.checked = i.students.some(function (i) {
                          return i.studentId === ite.userId;
                        });
                      } else {
                        ite.disabled = e.operateType === 0 && i.members.filter(function (i) {
                          return i.userId === ite.userId;
                        });
                        ite.checked = i.members.filter(function (i) {
                          return i.userId === ite.userId;
                        });
                      }
                    });
                  });
                }
              });
            });
            state.groupList.forEach(function (item, index) {
              changeGroup(item, index);
              changeClass({}, index);
            });
            changeGroup({}, 0);
            // 发布操作，需要禁用已发布群组
            state.groupList.forEach(function (e) {
              state.checkStudents.forEach(function (i) {
                if (i.groupId === e.groupId) {
                  e.members.forEach(function (item) {
                    item[Object.keys(item)[0]].forEach(function (ite) {
                      if (i !== null && i !== void 0 && i.students) {
                        ite.disabled = i.students.some(function (i) {
                          return i.studentId === ite.userId;
                        });
                        ite.checked = i.students.some(function (i) {
                          return i.studentId === ite.userId;
                        });
                      } else {
                        ite.disabled = e.operateType === 1 || i.members.some(function (i) {
                          return i.userId === ite.userId;
                        });
                        ite.checked = i.members.some(function (i) {
                          return i.userId === ite.userId;
                        });
                      }
                    });
                  });
                }
              });
            });
            state.groupList.forEach(function (item, index) {
              changeGroup(item, index);
              changeClass({}, index);
            });
            changeGroup({}, 0);
          }
          state.groupList.forEach(function (item) {
            item === null || item === void 0 || item.members.forEach(function (ite) {
              // 如果成员全禁则类型全禁
              if (ite[Object.keys(ite)[0]].every(function (it) {
                return it.disabled;
              })) {
                ite.disabled = true;
              } else {
                ite.disabled = false;
              }
              // 如果类型全禁 则班级全禁
              if (item.members.every(function (i) {
                return i.disabled;
              }) || item.operateType === 1) {
                item.disabled = true;
              } else {
                item.disabled = false;
              }
              // 如果类型全勾 则班级勾选
              if (item.members.every(function (i) {
                return i.checked;
              })) {
                item.checked = true;
              } else {
                item.checked = false;
              }
            });
          });
          state.allGroupsDisabled = state.groupList.every(function (item) {
            return item.disabled;
          }); // 所有群组禁用
        }
      });
    };
    // 初始化日期相关
    var initDate = function initDate() {
      // 禁用日期
      state.timePickerProps = {
        disableTime: function disableTime() {
          var hours = new Array(24).fill(null).map(function (_, i) {
            return i;
          });
          var times = new Array(60).fill(null).map(function (_, i) {
            return i;
          });
          var nowH = Number(dayjs().format('H'));
          var nowM = Number(dayjs().format('m'));
          var nowS = Number(dayjs().format('s'));
          return {
            hour: hours.filter(function (e) {
              return e < nowH;
            }),
            minute: times.filter(function (e) {
              return e < nowM;
            }),
            second: times.filter(function (e) {
              return e < nowS;
            })
          };
        }
      };
      // 日期初始赋值
      var start = new Date();
      var end = new Date(+new Date() + 30 * 24 * 60 * 60 * 1000);
      var endPractice = new Date(+new Date() + 3 * 24 * 60 * 60 * 1000);
      var startFormat = dayjs(start).format('YYYY-MM-DD HH:mm');
      var endFormat = dayjs(end).format('YYYY-MM-DD HH:mm');
      var Practice = dayjs(endPractice).format('YYYY-MM-DD HH:mm');
      state.resourceDate = startFormat;
      state.courseDate = [startFormat, endFormat];
      if (operateType.value !== 'set') {
        state.practiceDate = [startFormat, Practice];
      }
    };
    var sureLoading = ref(false);
    var handleConfirm = debounce(function () {
      var excPubs = [];
      state.groupList.forEach(function (item) {
        item.members.forEach(function (ite) {
          var _ite$Object$keys$;
          (_ite$Object$keys$ = ite[Object.keys(ite)[0]]) === null || _ite$Object$keys$ === void 0 || _ite$Object$keys$.forEach(function (it) {
            if (it.checked) {
              excPubs.push(it);
            }
          });
        });
      });
      if (!excPubs.length) {
        MessagePlugin.warning('请选择成员！');
        return;
      }
      if (!state.practiceDate.length) {
        MessagePlugin.warning('请选择起止时间！');
        return;
      }
      releaseExercise();
    });

    // 处理发布习练时候api所需群组数据
    var getExePubGroups = function getExePubGroups() {
      var filterUserArr = [];
      var list = [];
      state.groupList.forEach(function (item) {
        item === null || item === void 0 || item.members.forEach(function (ite) {
          ite[Object.keys(ite)[0]].forEach(function (it) {
            if (it.checked) {
              filterUserArr.push(_objectSpread(_objectSpread({}, it), item));
            }
          });
        });
      });
      var obj = {};
      filterUserArr.forEach(function (item) {
        if (obj[item.groupId]) {
          obj[item.groupId].students.push({
            userId: item.userId,
            userName: item.userName,
            disabled: item.disabled
          });
        } else {
          obj[item.groupId] = _objectSpread(_objectSpread({}, item), {}, {
            students: [{
              userId: item.userId,
              student: item.userName,
              disabled: item.disabled
            }]
          });
        }
      });
      Object.values(obj).forEach(function (item) {
        item.members = item.members.filter(function (ite) {
          return ite[Object.keys(ite)[0]].some(function (i) {
            return i.checked && !i.disabled;
          });
        });
        if (operateType.value === 'set' || item.members.length) {
          var pushItem = {
            groupId: item.groupId,
            groupName: item.groupName,
            members: item.students.map(function (ite) {
              return {
                userName: ite.student || ite.userName,
                userId: ite.userId,
                avatar: ite.avatar || ''
                // groupId: item.groupId,
              };
            })
          };
          list.push(pushItem);
        }
      });
      return list;
    };

    // 发布习练
    var releaseExercise = function releaseExercise() {
      if (sureLoading.value) return;
      var userInfo = getStore({
        name: 'userInfo'
      });
      var data = {
        startTime: state.practiceDate[0],
        endTime: state.practiceDate[1],
        duration: state.recommendTimeShow === '不限' ? 0 : state.recommendTimeShow,
        reviewType: state.practiceReadWay,
        viewAnswerType: state.practiceAnswerTime,
        isSendToGroup: state.practiceIsPubToGroup ? 1 : 0,
        userId: userInfo.id,
        groups: getExePubGroups(),
        paperId: props.paper.id,
        name: userInfo.name || '',
        avatar: userInfo.avatar || ''
      };
      if (state.practiceAnswerTime === 2) {
        data.controllerSwitch = state.practiceAnswerShow ? 1 : 0;
      }
      sureLoading.value = true;
      console.log('getExercisesPaperPub', data);
      getExercisesPaperPub(data).then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('发布成功！');
          emit('close', 'success');
        } else {
          MessagePlugin.warning('发布失败！');
        }
      }).finally(function () {
        sureLoading.value = false;
      });
    };
    onMounted(function () {
      getGroupList();
      initDate();
    });
    return function (_ctx, _cache) {
      var _component_t_steps = _resolveComponent("t-steps");
      var _component_t_checkbox = _resolveComponent("t-checkbox");
      var _component_t_popup = _resolveComponent("t-popup");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_date_range_picker = _resolveComponent("t-date-range-picker");
      var _component_t_select = _resolveComponent("t-select");
      var _component_t_radio = _resolveComponent("t-radio");
      var _component_t_radio_group = _resolveComponent("t-radio-group");
      var _component_t_switch = _resolveComponent("t-switch");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return state.groupList.length ? (_openBlock(), _createBlock(_component_t_dialog, {
        key: 0,
        visible: visible.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = function ($event) {
          return visible.value = $event;
        }),
        class: "publish-step-dialog",
        width: "956px",
        header: "发布",
        placement: "center",
        footer: false,
        "on-close": close,
        closeOnOverlayClick: false
      }, {
        default: _withCtx(function () {
          return [currentStep.value === 'first' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_t_steps, {
            modelValue: currentStep.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return currentStep.value = $event;
            }),
            options: steps
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createVNode(_component_t_checkbox, {
            modelValue: allGroupsChecked.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return allGroupsChecked.value = $event;
            }),
            disabled: state.allGroupsDisabled,
            onChange: changeAllGroups
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[14] || (_cache[14] = [_createTextVNode(" 全部群组 ", -1)]));
            }),
            _: 1
          }, 8, ["modelValue", "disabled"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.groupList, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass({
                'check-box-item': true,
                active: activeIndex.value === index
              }),
              key: index
            }, [_createVNode(_component_t_checkbox, {
              disabled: item.disabled,
              indeterminate: item.halfChecked,
              modelValue: item.checked,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return item.checked = $event;
              },
              onChange: function onChange($event) {
                return changeClass(item, index);
              }
            }, null, 8, ["disabled", "indeterminate", "modelValue", "onUpdate:modelValue", "onChange"]), _createElementVNode("span", {
              class: "item-label",
              onClick: function onClick($event) {
                return changeGroup(item, index);
              }
            }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.groupName), 1), item.groupType == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "系统群")) : _createCommentVNode("", true)], 8, _hoisted_5)], 2);
          }), 128))]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_t_checkbox, {
            modelValue: state.groupList[activeIndex.value].checked,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return state.groupList[activeIndex.value].checked = $event;
            }),
            onChange: _cache[3] || (_cache[3] = function ($event) {
              return changeClass(state.groupList[activeIndex.value], activeIndex.value);
            }),
            disabled: state.groupList[activeIndex.value].disabled,
            indeterminate: state.groupList[activeIndex.value].halfChecked,
            class: "all-check"
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[15] || (_cache[15] = [_createTextVNode(" 全选 ", -1)]));
            }),
            _: 1
          }, 8, ["modelValue", "disabled", "indeterminate"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.groupList[activeIndex.value].members, function (ite, index) {
            return _openBlock(), _createElementBlock("div", {
              class: "group-item",
              key: index
            }, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_t_checkbox, {
              class: "title-check",
              disabled: Object.keys(ite)[0] === 'teacher' || ite.disabled,
              indeterminate: ite.halfChecked,
              modelValue: ite.checked,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return ite.checked = $event;
              },
              onChange: function onChange($event) {
                return changeType(index);
              }
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(typeObj[Object.keys(ite)[0]]), 1)];
              }),
              _: 2
            }, 1032, ["disabled", "indeterminate", "modelValue", "onUpdate:modelValue", "onChange"]), _createVNode(_component_t_popup, {
              placement: "right",
              content: "\u6210\u5458\u7C7B\u578B\u4E3A".concat(typeObj[Object.keys(ite)[0]]),
              "destroy-on-close": ""
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("img", {
                  src: require('@/assets/help.svg'),
                  alt: ""
                }, null, 8, _hoisted_10)];
              }),
              _: 1
            }, 8, ["content"])]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(ite)[0], function (it) {
              return _openBlock(), _createBlock(_component_t_checkbox, {
                modelValue: it.checked,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return it.checked = $event;
                },
                key: it.userId,
                disabled: it.disabled || Object.keys(ite)[0] === 'teacher',
                onChange: function onChange($event) {
                  return changeStu(index);
                }
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(it.userName), 1)];
                }),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]);
            }), 128))])]);
          }), 128))])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_t_button, {
            theme: "primary",
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return changeStep('second');
            })
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[16] || (_cache[16] = [_createTextVNode("下一步", -1)]));
            }),
            _: 1
          }), _createVNode(_component_t_button, {
            theme: "default",
            onClick: close
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[17] || (_cache[17] = [_createTextVNode("取消", -1)]));
            }),
            _: 1
          })])])) : _createCommentVNode("", true), currentStep.value === 'second' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_t_steps, {
            modelValue: currentStep.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return currentStep.value = $event;
            }),
            options: steps
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_t_popup, {
            class: "placement right",
            content: noticeText.value,
            destroyOnClose: ""
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[18] || (_cache[18] = [_createElementVNode("div", {
                class: "i-style"
              }, "i", -1)]));
            }),
            _: 1
          }, 8, ["content"]), _cache[19] || (_cache[19] = _createElementVNode("span", {
            class: "label"
          }, "起止时间：", -1)), _createVNode(_component_t_date_range_picker, {
            modelValue: state.practiceDate,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return state.practiceDate = $event;
            }),
            "disable-date": {
              before: _unref(dayjs)(+new Date() - 86400000).format()
            },
            "time-picker-props": state.timePickerProps,
            format: "YYYY-MM-DD HH:mm",
            "enable-time-picker": "",
            "allow-input": "",
            clearable: "",
            onPick: datePick,
            onChange: dateChange
          }, null, 8, ["modelValue", "disable-date", "time-picker-props"])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_t_popup, {
            class: "placement right",
            content: noticeText2.value,
            destroyOnClose: ""
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[20] || (_cache[20] = [_createElementVNode("div", {
                class: "i-style"
              }, "i", -1)]));
            }),
            _: 1
          }, 8, ["content"]), _cache[21] || (_cache[21] = _createElementVNode("span", {
            class: "label_time"
          }, "推荐用时：", -1)), _createElementVNode("div", _hoisted_18, [_createVNode(_component_t_select, {
            modelValue: state.recommendTimeShow,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
              return state.recommendTimeShow = $event;
            }),
            options: recommendTime.value,
            placeholder: "请选择内容"
          }, null, 8, ["modelValue", "options"])])]), _createElementVNode("div", _hoisted_19, [_cache[22] || (_cache[22] = _createElementVNode("span", {
            class: "label"
          }, "批阅方式：", -1)), _createVNode(_component_t_radio_group, {
            modelValue: state.practiceReadWay,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return state.practiceReadWay = $event;
            }),
            "default-value": "0"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, function (option) {
                return _openBlock(), _createBlock(_component_t_radio, {
                  value: option.value,
                  disabled: option.disabled,
                  key: option.value
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(option.label), 1)];
                  }),
                  _: 2
                }, 1032, ["value", "disabled"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_t_popup, {
            class: "placement right",
            content: noticeText3.value,
            destroyOnClose: ""
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[23] || (_cache[23] = [_createElementVNode("div", {
                class: "i-style"
              }, "i", -1)]));
            }),
            _: 1
          }, 8, ["content"]), _cache[24] || (_cache[24] = _createElementVNode("span", {
            class: "label"
          }, "答案公布时机：", -1)), _createVNode(_component_t_radio_group, {
            modelValue: state.practiceAnswerTime,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
              return state.practiceAnswerTime = $event;
            }),
            "default-value": "1"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionTwice.value, function (option) {
                return _openBlock(), _createBlock(_component_t_radio, {
                  value: option.value,
                  disabled: option.disabled,
                  key: option.value
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(option.label), 1)];
                  }),
                  _: 2
                }, 1032, ["value", "disabled"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue"])]), state.practiceAnswerTime === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_cache[25] || (_cache[25] = _createElementVNode("span", {
            class: "label"
          }, "答案是否可见：", -1)), _createVNode(_component_t_switch, {
            modelValue: state.practiceAnswerShow,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
              return state.practiceAnswerShow = $event;
            }),
            class: "switch"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_cache[28] || (_cache[28] = _createElementVNode("span", {
            class: "label"
          }, "是否同步到群组动态：", -1)), _createVNode(_component_t_radio_group, {
            modelValue: state.practiceIsPubToGroup,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
              return state.practiceIsPubToGroup = $event;
            }),
            "default-value": false
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_radio, {
                value: false
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[26] || (_cache[26] = [_createTextVNode("不同步", -1)]));
                }),
                _: 1
              }), _createVNode(_component_t_radio, {
                value: true
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[27] || (_cache[27] = [_createTextVNode("同步", -1)]));
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_t_button, {
            theme: "primary",
            loading: sureLoading.value,
            onClick: _unref(handleConfirm)
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[29] || (_cache[29] = [_createTextVNode("确定", -1)]));
            }),
            _: 1
          }, 8, ["loading", "onClick"]), _createVNode(_component_t_button, {
            theme: "default",
            onClick: _cache[12] || (_cache[12] = function ($event) {
              return changeStep('first');
            })
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[30] || (_cache[30] = [_createTextVNode("上一步", -1)]));
            }),
            _: 1
          })])])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible"])) : _createCommentVNode("", true);
    };
  }
};